angular.module("avant.filters").filter "ProductMoney",
["$filter",
($filter) ->
  (amount, config = { "currency_symbol": "$" }, precision = 2, abs) ->
    if abs?
      amount = Math.abs(amount)
    "#{config.currency_symbol}#{$filter('number')(amount, precision)}"
]
